import { API } from "aws-amplify";
import { getServiceRequest } from "~/graphql/queries";
import * as APITypes from "~/API";

export const EMPTY_SERVICE_REQUEST: APITypes.ServiceRequest = {
  id: "",
  title: "",
  creatorID: "",
  creatorName: "",
  handlerID: "",
  handlerName: "",
  watcherID: "",
  watcherName: "",
  tenantID: "",
  tenantName: "",
  contractor: "",
  entityID: "",
  entityType: "property",
  dateCreated: "",
  dateUpdated: "",
  status: APITypes.ServiceRequestStatusType.Running,
  description: "",
  estimatedCost: 0,
  finalCost: 0,
  type: APITypes.ServiceRequestType.Other,
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  __typename: "ServiceRequest",
  emergency: false,
  createdAt: "",
  updatedAt: "",
  isUpgrade: false,
  _version: 0,
  _lastChangedAt: 0,
};

export const getServiceRequestDetails = async (requestID: string) => {
  try {
    const response = (await API.graphql({
      query: getServiceRequest,
      variables: {
        id: requestID,
      },
    })) as { data?: APITypes.GetServiceRequestQuery };

    return {
      success: true,
      data: response.data?.getServiceRequest || EMPTY_SERVICE_REQUEST,
    };
  } catch (error) {
    console.error("Error getting service request details", error);
    return {
      success: false,
      data: EMPTY_SERVICE_REQUEST,
      error,
    };
  }
};
